<template lang="html">
  <div>
    <div id="hideImg">
      <div class="share-container" id="shareImg">
        <div class="bg">
          <img src="~mobile/pic/shareWx/logo_w.png" class="logo"/>
          <div class="content-bg">
            <div class="content">
              <div class="title" v-if="timeLineItem.display_title != 0">{{timeLineItem.title}}</div>
              <div class="title" v-else>{{theme_title}}</div>
              <div class="summary" v-html="timeLineItem.summary" v-if="timeLineItem.summary"></div>
              <div class="line" v-if="line_content && line_content.length > 0">

                  <div class="line-list" v-if="line_type == 0">
                      <div v-for="item1,index1 in year" :key="index1" class="line-li clear">
                          <div class="year-tip">{{item1}}年</div>
                          <div class="line-content">
                              <div v-for="item2,index2 in topic_line_year[item1]" :key="index2">
                                  <div class="topic-title">{{item2.title}}</div>
                                  <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item2.content_unsigned}}</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="line-list" v-else>
                      <div v-for="item1,index1 in year" :key="index1" class="line-li">
                          <div class="year-tip">{{item1}}年</div>

                          <div
                              v-for="item2,index2 in month"
                              v-if="moment(item2).format('YYYY') == item1 && line_type == 1"
                              :key="index2"
                              class="line-li-m clear"
                          >
                              <div class="line-time">{{item2 | time_moment('M月')}}</div>
                              <div class="line-content">
                                  <div v-for="item3,index3 in topic_line_month[item1][moment(item2).format('M')]" :key="index3">
                                      <div class="topic-title">{{item3.title}}</div>
                                      <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                  </div>
                              </div>
                          </div>

                          <div
                              v-for="item2,index2 in date"
                              v-if="moment(item2).format('YYYY') == item1 && line_type > 1"
                              :key="index2"
                              class="line-li-m clear"
                          >
                              <div class="line-time">{{item2 | time_moment('MM-DD')}}</div>
                              <div class="line-content">
                                  <div v-for="item3,index3 in topic_line_date[item1][moment(item2).format('MM-DD')]" :key="index3">
                                      <p
                                          class="topic-time"
                                          v-if="line_type == 3"
                                      >
                                          {{item3.oldest_news_publish_time | time_moment('HH:mm')}}
                                      </p>
                                      <div class="topic-title">{{item3.title}}</div>
                                      <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                  </div>
                              </div>
                          </div>

                      </div>

                  </div>
              </div>
            </div>
          </div>
          <div class="content-footer">数据来源：动脉橙产业智库</div>
          <div class="footer">
            <img :src="xcx_code" />
            <p>进入小程序，查看更多详情</p>
          </div>
        </div>
      </div>
    </div>
    <div id="showImg">
      <img :src="imgbase" />
    </div>
    <div class="loading_img" v-if="loading">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>

</template>

<script>
import html2canvas from 'html2canvas'
import { share } from 'mobile/js/wx_share'
import { themeInfo, getTimeLine, wxShare, getdgxcxcode } from '../service'
import moment from 'moment'

export default {
  data() {
    return {
      loading: true,
      imgbase: '',
      theme_title: '',
      timeLineItem: '',
      topic_line: {},
      year: [],
      month: [],
      date: [],
      topic_line_year: {},
      topic_line_month: {},
      topic_line_date: {},
      moment: moment,
      loading1: false,
      loading2: false,
      xcx_code: ''
    }
  },
  computed: {
    theRequest() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    line_content() {
      return this.timeLineItem.line_content
    },
    line_type() {
      return this.timeLineItem.time_format
    },
    getLoading() {
      return this.loading1 && this.loading2
    }
  },
  methods: {
    async getTimeLine() {
      let params = {
        theme_uid: this.theRequest.theme_uid,
        time_line_id: this.theRequest.time_line_id
      }
      let res = await getTimeLine( params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'timeLineItem', res.time_line[0])
        this.$set(this.$data, 'theme_title', res.theme_info[0].title)
        this.throughData()
        _czc.push(['_trackEvent', '分享进入页面', this.theme_title+'_'+this.timeLineItem.title])
      } else {
        this.$Message.error(res.message)
      }
    },
    throughData() {
      this.line_content.map((a) => {
        let y = moment(a.oldest_news_publish_time).format('YYYY'),
            m = moment(a.oldest_news_publish_time).format('YYYY-MM'),
            d = moment(a.oldest_news_publish_time).format('YYYY-MM-DD')
        let yIndex = this.year.findIndex((b) => b == y),
            mIndex = this.month.findIndex((b) => b == m),
            dIndex = this.date.findIndex((b) => b == d)
        if (yIndex == -1) this.year.push(y)
        if (mIndex == -1) this.month.push(m)
        if (dIndex == -1) this.date.push(d)
      })
      this.year.map((a) => {
        this.topic_line_year[a] = []
        this.topic_line_month[a] = {}
        this.topic_line_date[a] = {}
      })
      this.month.map((a) => {
        let y = moment(a).format('YYYY'),
            m = moment(a).format('M')
        this.topic_line_month[y][m] = []
      })
      this.date.map((a) => {
        let y = moment(a).format('YYYY'),
            m = moment(a).format('M'),
            d = moment(a).format('MM-DD')
        this.topic_line_date[y][d] = []
      })
      this.line_content.map((a) => {
        let y = moment(a.oldest_news_publish_time).format('YYYY'),
            m = moment(a.oldest_news_publish_time).format('M'),
            d = moment(a.oldest_news_publish_time).format('MM-DD')
        this.topic_line_year[y].push(a)
        this.topic_line_month[y][m].push(a)
        this.topic_line_date[y][d].push(a)
      })
      this.$forceUpdate()
      this.$nextTick(() => {this.loading1 = true})
    },
    handleCreateImage() {
      html2canvas(document.getElementById('shareImg'),{ scale: 2, useCORS: true, tainttest: true }).then((canvas) => {
        let save_url= canvas.toDataURL("image/png")
        this.$set(this.$data, 'imgbase', save_url)
        // console.log(this.imgbase)
        this.loading = false
      })
    },
    async themeShare() {
      let res = await wxShare({"url":this.$store.state.req_url+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: this.timeLineItem.title,
        desc: this.timeLineItem.unsign_summary,
        link: this.$store.state.req_url + '/mindex' + this.$route.fullPath,
        imgUrl: this.$store.state.req_url+'/share_pro.png'
      }, this, window.location.href)
    },
    async getXcxCode() {
      let res = await getdgxcxcode({
        page: 'pages/themeDetail/themeDetail',
        scene: this.$route.query.theme_uid
        // scene: '47b3f510fbfd372859d515e186201584'
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.xcx_code = 'data:image/png;base64,' + res.info
        this.$nextTick(() => {this.loading2 = true})
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getTimeLine()
  },
  mounted() {
    this.themeShare()
    this.getXcxCode()
  },
  watch: {
    getLoading(val) {
      if(val) this.handleCreateImage()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/shareLoading.stylus'
@import '~mobile/styles/shareWx.stylus'
#hideImg
  overflow: hidden
  height: 0
#showImg img
  width: 100%
  display: block
.share-container .content
  padding: 60px 0 40px
  .title
  .summary
    padding: 0 40px
.line
  padding: 120px 40px 0
  background-image: url('~mobile/pic/shareTime/circle.png')
  background-position: 0 -30px
  background-size: 148px auto
  background-repeat: no-repeat
  .line-list
    position: relative
    &:before
      position: absolute
      content: ''
      top: 24px
      bottom: 0
      left: 12px
      border-right: 2px solid #ffc343
      z-index: 0
    .line-li
      padding-left: 50px
      &+.line-li
        margin-top: 30px
      .year-tip
        width: 120px
        height: 50px
        background-image: url('~mobile/pic/shareTime/year-bg.png')
        background-repeat: no-repeat
        background-size: 120px 50px
        background-position: -1px 0
        padding-left: 26px
        line-height: 46px
        padding-top: 4px
        color: #fff
        font-size: 24px
        font-weight: 600
        margin-left: -18px
        position: relative
        &:before
          content: ''
          position: absolute
          width: 26px
          height: 26px
          background-image: url('~mobile/pic/shareTime/year-icon.png')
          background-size: 100%
          left: -32px
          top: 12px
      .line-time
        color: #ffc343
        font-weight: bold
        font-size: 32px
        margin-top: 30px
        position: relative
        &:before
          content: ''
          position: absolute
          width: 14px
          height: 14px
          background-color: #ffc343
          border-radius: 50%
          left: -44px
          top: 8px
      .line-content
        background-color: #fff
        padding: 0 32px
        border-radius: 16px
        margin-top: 20px
        border:1px solid rgba(255, 186, 67, 1);
        > div
          padding: 32px 0
          &+div
            border-top: 1px solid #F7EEE5
        .topic-title
          color: #E66900
          line-height: 40px
          font-size: 28px
          margin: 11px 0
          font-weight: 600
          word-wrap: break-word
        .topic-content
          color: #E66900
          line-height: 44px
          font-size: 28px
          margin: 16px 0 -.1rem
          word-wrap: break-word
          opacity: 0.8
        .topic-time
          font-size: 24px
          margin-bottom: 16px
          color: #fede7e
          font-weight: bold
</style>
